<template>
  <div class="policy-page">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3EA56E"
      spinner="bar-fade-scale"
    />
    
    <v-snackbar v-model="snackbar" color="#3EA56E" right :timeout="timeout" class="mt-12">
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-2">mdi-check-circle</v-icon>
        <span class="font-weight-medium">{{ msg }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="snackbar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-container class="py-6 py-md-12">
      <v-layout wrap>
        <!-- Header Section -->
        <v-flex xs12>
          <div class="header-section mb-8 mb-md-12 text-left">
            <h1 class="page-title">Contact Us</h1>
            <v-divider class="title-divider mt-2"></v-divider>
          </div>
        </v-flex>

        <!-- Main Content Section -->
        <v-flex xs12 md5 class="mb-10 mb-md-0 pr-md-12 text-left">
          <div class="contact-info-container">
            <h2 class="section-heading mb-4">Get In Touch</h2>
            <p class="section-description mb-8">
              Feel free to contact us any time and We will get back to you as soon as we can.
            </p>

            <div class="info-list">
              <div class="info-item mb-6">
                <div class="icon-wrapper">
                  <v-icon color="#3EA56E">mdi-email-outline</v-icon>
                </div>
                <div class="info-content">
                  <a href="mailto:sithosh@hotmail.com" class="info-value">sithosh@hotmail.com</a>
                </div>
              </div>

              <div class="info-item mb-6">
                <div class="icon-wrapper">
                  <v-icon color="#3EA56E">mdi-phone-outline</v-icon>
                </div>
                <div class="info-content">
                  <a href="tel:+918744807234" class="info-value">91-8744807234</a>
                </div>
              </div>

              <div class="info-item mb-8">
                <div class="icon-wrapper">
                  <v-icon color="#3EA56E">mdi-map-marker-outline</v-icon>
                </div>
                <div class="info-content">
                  <div class="info-value">
                    <strong class="brand-name">KL06</strong><br />
                    2/434, murickassery, idukki, kerala, 685604
                  </div>
                  <div class="tax-info mt-2">
                    <span>GSTIN : 32AQUPT3997K1ZR</span><br />
                    <span>State: 32-Kerala</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Social Links -->
            <div class="social-section mt-10">
              <span class="social-label mr-4">Follow Us:</span>
              <v-btn :href="footer.twitterlink" target="_blank" icon small class="social-btn mr-2">
                <v-icon size="20">mdi-twitter</v-icon>
              </v-btn>
              <v-btn :href="footer.fblink" target="_blank" icon small class="social-btn mr-2">
                <v-img width="18" height="18" contain src="../../assets/Images/facebook.svg"></v-img>
              </v-btn>
              <v-btn :href="footer.linkedInlink" target="_blank" icon small class="social-btn">
                <v-img width="18" height="18" contain src="../../assets/Images/linkedin.svg"></v-img>
              </v-btn>
            </div>
          </div>
        </v-flex>

        <!-- Form Section -->
        <v-flex xs12 md7>
          <v-card flat class="form-container elevation-0 pa-6 pa-md-10">
            <h2 class="section-heading mb-6">Leave us a Message</h2>
            <v-form ref="form" v-model="valid">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="contact.name"
                    :rules="[rules.required]"
                    label="Full Name"
                    outlined
                    dense
                    class="custom-field mb-2"
                    placeholder="Enter your name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="contact.email"
                    :rules="[rules.email, rules.required]"
                    label="Email Address"
                    outlined
                    dense
                    class="custom-field mb-2"
                    placeholder="Enter your email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="contact.message"
                    :rules="[rules.required]"
                    label="Your Message"
                    outlined
                    rows="5"
                    class="custom-field mb-4"
                    placeholder="How can we help you?"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    block
                    height="48"
                    color="#3EA56E"
                    dark
                    class="submit-btn elevation-0"
                    @click="add()"
                  >
                    SEND MESSAGE
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      msg: "",
      timeout: 5000,
      snackbar: false,
      appLoading: false,
      valid: true,
      footer: {},
      contact: { name: null, email: null, message: null },
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  beforeMount() {
    this.getFooterData();
  },
  methods: {
    getFooterData() {
      axios({
        method: "GET",
        url: "/footer/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.footer = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    add() {
      if (this.$refs.form.validate()) {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/contact/us",
          data: this.contact,
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.msg = "Your message has been sent successfully!";
              this.snackbar = true;
              this.contact = { name: null, email: null, message: null };
              this.$refs.form.resetValidation();
            } else {
              this.msg = response.data.msg || "Failed to send message.";
              this.snackbar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            console.error("Error sending contact message:", err);
            this.msg = "Something went wrong. Please try again later.";
            this.snackbar = true;
          });
      }
    },
  },
};
</script>

<style scoped>
.policy-page {
  background-color: #ffffff;
  min-height: 90vh;
}

.page-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 28px;
  color: #2c3e50;
  text-transform: uppercase;
  text-align: left;
}

.title-divider {
  border-width: 1px;
  border-color: #eee !important;
}

.section-heading {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
  text-transform: none;
  text-align: left;
}

.section-description {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #4b5563;
  line-height: 1.6;
  text-align: left;
}

.info-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.info-item {
  display: flex;
  align-items: center; /* Changed to center icons with content */
}

.icon-wrapper {
  background-color: #f0faf4; /* Light green background */
  padding: 10px;
  border-radius: 50%; /* Circular for cleaner look since labels are gone */
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-content {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.info-value {
  font-family: "ibmregular", sans-serif;
  font-size: 16px;
  color: #334155;
  text-decoration: none;
  line-height: 1.5;
}

.info-value:hover {
  color: #3EA56E;
}

.brand-name {
  color: #2c3e50;
}

.tax-info {
  font-family: "sofialight", sans-serif;
  font-size: 13px;
  color: #64748b;
  border-top: 1px solid #f1f5f9;
  padding-top: 4px;
}

.social-section {
  display: flex;
  align-items: center;
}

.social-label {
  font-family: "ibmsemibold", sans-serif;
  font-size: 14px;
  color: #94a3b8;
}

.social-btn {
  background-color: #f8fafc;
  transition: all 0.3s ease;
}

.social-btn:hover {
  background-color: #3EA56E;
  color: white !important;
}

.form-container {
  background-color: #ffffff;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px;
}

.submit-btn {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  letter-spacing: 1px;
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
}

.submit-btn:active {
  transform: translateY(0);
}

/* Custom styles for Vuetify inputs */
.custom-field >>> .v-input__slot {
  border-radius: 8px !important;
}

.custom-field >>> .v-label {
  font-family: "ibmregular", sans-serif;
  font-size: 14px;
}

.custom-field >>> input,
.custom-field >>> textarea {
  font-family: "ibmregular", sans-serif;
  font-size: 15px;
  color: #1e293b;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 22px;
  }
  
  .form-container {
    padding: 20px !important;
  }
  
  .info-item {
     margin-bottom: 20px;
  }
}
</style>